import { BMC_BLOCKS, BMC_STAGES, BMC_STAGES_TO_INTEGER } from './bmc_constants';

const isValidBlock = (block) => blocksArray().includes(block);

const blocksArray = () => [
  BMC_BLOCKS.CUSTOMER_SEGMENTS,
  BMC_BLOCKS.CUSTOMER_RELATIONSHIPS,
  BMC_BLOCKS.CHANNELS,
  BMC_BLOCKS.REVENUE_STREAMS,
  BMC_BLOCKS.KEY_PROPOSITIONS,
  BMC_BLOCKS.KEY_ACTIVITIES,
  BMC_BLOCKS.KEY_RESOURCES,
  BMC_BLOCKS.KEY_PARTNERS,
  BMC_BLOCKS.COST_STRUCTURE,
];

const stagesArray = () => Object.values(BMC_STAGES);


const nextStage = (stage) => {
  let next = stagesArray()[BMC_STAGES_TO_INTEGER[stage] + 1];
  if (!next) {
    next = BMC_STAGES.FREE;
  }

  return next;
};

const initFiltersFromBmcStages = () => {
  const filters = {};
  Object.values(BMC_STAGES).forEach((value) => {
    filters[value] = false;
  });
  return filters;
};

export {
  isValidBlock,
  blocksArray,
  initFiltersFromBmcStages,
  stagesArray,
  nextStage,
};
